import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
  reducerPath: "authApi",
  tagTypes: ['Auth'],
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_COGNITO_DOMAIN }),
  endpoints: (builder) => ({
    getAuthInfo: builder.mutation({
      query: (authPostBody) => {
        return {
          method: 'POST',
          url: 'oauth2/token',
          body: authPostBody,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
      },
    }),
  }),
});

export const {
  useGetAuthInfoMutation
} = authApi;